import { render } from "./googlelogin.vue?vue&type=template&id=b8f68a8a"
import script from "./googlelogin.vue?vue&type=script&lang=js"
export * from "./googlelogin.vue?vue&type=script&lang=js"

import "./googlelogin.vue?vue&type=style&index=0&id=b8f68a8a&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__